"use strict";

exports.__esModule = true;

require('./gallery.css');

exports.default = {
  "gallery": "pf-l-gallery",
  "modifiers": {
    "gutter": "pf-m-gutter"
  }
};